<script>
	import {
		XCircleIcon,
		SearchIcon,
		PlusCircleIcon,
	} from "svelte-feather-icons"
	import { Link } from "svelte-navigator"
	import { createEventDispatcher } from 'svelte'
	import {auth, hasRole} from '../auth'

	export let filter = null
	export let newUrl = null
	export let hideNew = false
	
	const dispatch = createEventDispatcher()

</script>

<div class="buttonBox">
	<div class="filterBox">
		<input
			type="text"
			placeholder="Filter"
			bind:value={filter}
			autofocus 
		/>
		<span class="search"><SearchIcon /></span>
		<span class="clearSearch" on:click={() => (filter = "")}
			><XCircleIcon /></span
		>
	</div>
	{#if newUrl && hasRole($auth, 'con')}
		<Link class="newLink" to={newUrl}><PlusCircleIcon /></Link>
	{:else if !hideNew && hasRole($auth, 'con')}
		<a href="#" class="newLink" on:click={() => dispatch('new')}><PlusCircleIcon /></a>
	{/if}

</div>

<style>
	/** Filter flight view **/

	.buttonBox {
		display: flex;
		color: #808080;
		justify-content: space-between;
		align-items: center;
		width: 100%;
	}
	.clearSearch {
		color: white
	}

	.buttonBox :global(.newLink) {
		color: white;
		margin-left: 8px;
		margin-top: 4px;
	}

	.filterBox {
		flex: 1;
		display: flex;
		border-radius: 8px;
		background-color: rgba(0, 0, 0, 0.4);
		padding: 4px;
		align-items: center;
	}

	.filterBox input {
		flex: 1;
		border: 0;
		background: transparent;
		margin-bottom: 0;
		font-size: 12pt;
		padding: 4px;
		height: 24px;
	}

	.filterBox input:focus {
		outline: 0;
		border: 0;
	}

	.filterBox span {
		height: 24px;
		width: 24px;
	}
</style>
